/**
 * This file was automatically generated by @cosmwasm/ts-codegen@1.12.1.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run the @cosmwasm/ts-codegen generate command to regenerate this file.
 */

import * as _0 from "./Registry.types";
import * as _1 from "./Registry.client";
import * as _2 from "./Registry.react-query";
export namespace contracts {
  export const Registry = {
    ..._0,
    ..._1,
    ..._2,
  };
}
